import NumberFormat from 'react-number-format';

type NumberFormatCustomProps = {
  inputRef: (instance: NumberFormat<number> | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  prefix?: string;
};

const NumberFormatCustom = ({
  inputRef,
  onChange,
  name,
  prefix = '$',
  ...others
}: NumberFormatCustomProps): JSX.Element => (
  <NumberFormat
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...others}
    data-testid="number-format-test-id"
    getInputRef={inputRef}
    thousandSeparator
    isNumericString
    prefix={prefix}
    allowNegative={false}
    decimalScale={2}
    onValueChange={(values): void => {
      onChange({
        target: {
          name,
          value: values.value,
        },
      });
    }}
  />
);

export default NumberFormatCustom;
